import React, { useEffect } from "react";
import { Button, Segment, Grid, Loader, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  getProductGroup,
  updateProductGroup,
  addProductsProductGroup,
  removeProductsProductGroup
} from "../../../../actions/product";

import CanViewPage from "../../../../role-based-access/CanViewPage";
import AddProducts from "./AddProducts";
import ProductGroupInfo from "./ProductGroupInfo";
import "../../productGroup.scss";

function EditViewPG(props) {
  const {
    productGroup = { products: [] },
    isLoading,
    getProductGroup,
    updateProductGroup,
    addProductsProductGroup,
    removeProductsProductGroup,
    match,
    history,
    businessclient=null,
  } = props;

  useEffect(() => getProductGroup(match.params.id), []);

  const addProducts = products =>
    addProductsProductGroup({ _id: match.params.id, products });
  const removeProduct = products =>
    removeProductsProductGroup({ _id: match.params.id, products });
  const productsFromPG =
    productGroup.products && productGroup.products.length > 0
      ? productGroup.products.map(({ _id }) => _id)
      : [];

  // console.log({ productsFromPG });

  if (!productGroup) {
    return (
      <div>
        <Loader active />
      </div>
    );
  } else {
    return (
      <CanViewPage path="/productgroup/:id">
        <main className="a-wrapper product-group-container">
          <Link to="/products/list/group">
            <Icon name="arrow left" /> Product group List
          </Link>
          <Segment>
            <div className="product-group-columns">
              <div className="product-group-columns__info">
                <ProductGroupInfo
                  
                  productGroup={productGroup}
                  removeProduct={removeProduct}
                  updateProductGroup={updateProductGroup}
                  history={history}
                />
              </div>
              <div className="product-group-columns__add-prod">
                <AddProducts
                  addProducts={addProducts}
                  productsFromPG={productsFromPG}
                  businessclient={businessclient}
                />
              </div>
            </div>
          </Segment>
        </main>
      </CanViewPage>
    );
  }
}

const mapStateToProps = (reduxState) => ({
  productGroup: reduxState.inventory.openProductGroup,
  businessclient: reduxState.inventory.openProductGroup.businessclient._id,
  isLoading: reduxState.loading.loading,
});
export default connect(mapStateToProps, {
  getProductGroup,
  updateProductGroup,
  addProductsProductGroup,
  removeProductsProductGroup
})(EditViewPG);
